/**
 * Normalize `indexQuery.filters` for cabinet list/count (GET /forms).
 * Cabinet selections come from `cabinetFilter.jsx` and customer `filterDefinitions` (tuple arrays
 * of selected values per index). This does not use the same pass-through rules as the generic
 * forms `optimizeIndexQueryFilters` (e.g. job / report–specific keys).
 */
const optimizeCabinetIndexQueryFilters = filters => {
  if (typeof filters !== 'object') {
    return filters;
  }
  const cleanedFilters = {};
  Object.keys(filters).forEach(key => {
    if (!Array.isArray(filters[key])) {
      cleanedFilters[key] = filters[key];
    } else {
      const cleanedItems = filters[key].filter(i => i !== null).map(i => i.id === undefined ? i : i.id);
      cleanedFilters[key] = cleanedItems;
    }
  });
  return cleanedFilters;
};
export default optimizeCabinetIndexQueryFilters;